document.addEventListener('page:loaded', function() {
  // 1. Identify the 'In stock' checkbox. 
  // Streamline uses value="1" for availability: in-stock
  const inStockCheckbox = document.querySelector('.tag__input[value="1"][name*="availability"]');

  // 2. Only run if we are on a collection page and the filter isn't already active
  if (inStockCheckbox && !inStockCheckbox.checked) {
    const urlParams = new URLSearchParams(window.location.search);
    
    // 3. Check if any other filters are already applied to prevent infinite loops
    if (!urlParams.has('filter.v.availability')) {
      inStockCheckbox.checked = true;
      
      // 4. Dispatch the 'change' event to trigger the theme's AJAX refresh
      inStockCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});
